<script>
  export default {
    props: {
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: ''
      }
    }
  }
</script>

<template>
  <div class="flex justify-center">
    <div class="rounded-full gif">
      <img
        :alt="alt"
        :src="src"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .gif {
    height: 16.5625rem;
    width: 16.5625rem;
    overflow: hidden;
    position: relative;
    img {
      height: auto;
      width: auto;
      min-height: 100%;
      min-width: 170%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
